/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { PresentationIssueRequestCompositionType } from '../../types/PresentationIssueRequestCompositionType';
import { PresentationIssueRequestDidMethod } from '../../types/PresentationIssueRequestDidMethod';

export const PresentationIssueRequest: core.serialization.Schema<
    serializers.PresentationIssueRequest.Raw,
    Truvity.PresentationIssueRequest
> = core.serialization.object({
    compositionType: core.serialization.property('composition_type', PresentationIssueRequestCompositionType),
    credentialIds: core.serialization.property('credential_ids', core.serialization.list(core.serialization.string())),
    didMethod: core.serialization.property('did_method', PresentationIssueRequestDidMethod.optional()),
    holder: core.serialization.string().optional(),
    keyId: core.serialization.property('key_id', core.serialization.string()),
});

export declare namespace PresentationIssueRequest {
    export interface Raw {
        composition_type: PresentationIssueRequestCompositionType.Raw;
        credential_ids: string[];
        did_method?: PresentationIssueRequestDidMethod.Raw | null;
        holder?: string | null;
        key_id: string;
    }
}
